/**
 * Direttiva Vue per abilitare il drag & drop su un elemento.
 * E' possibile passare alla direttiva un oggetto di configurazione nel seguente modo:
 * v-anm22-drag-and-drop="{group: '', start: (e) => {}, stop: (e) => {}}"
 * Ogni campo dell'oggetto è opzionale.
 * - group: permette di creare un gruppo di elementi in modo che il drag e il drop sia permesso solo
 *   con elementi dello stesso gruppo
 * - start: funzione che viene chiamata sull'evento ondragstart
 * - drop: funzione che viene chiamata sull'evento drop
 */

export const Anm22DragAndDrop = {
  bind(el, bindings, vnode) {
    const dragStart = (e) => {
      el.style.opacity = '0.4';
      e.dataTransfer.setData("group", e.target.dataset.group);
      if(bindings.value && bindings.value.start) {
        bindings.value.start(e);
      }
    };
    const dragOver = (e) => {
      if (e.preventDefault) {
        e.preventDefault();
      } 
      return false;
    };
    const dragEnd = (e) => {
      el.style.opacity = '1';
      return false;
    };
    const drop = (e) => {
      if(e.stopPropagation) {
        e.stopPropagation();
      }
      if(el.dataset.group) {
        if(el.dataset.group !== e.dataTransfer.getData("group")) {
          return;
        }
      }
      if(bindings.value && bindings.value.drop) {
          bindings.value.drop(e);
      }
    };
    el.setAttribute('draggable', true);
    if(bindings.value && bindings.value.group) {
      el.dataset.group = bindings.value.group;
    }
    el.addEventListener('dragstart', dragStart);
    el.addEventListener('dragover', dragOver);
    el.addEventListener('dragend', dragEnd);
    el.addEventListener('drop', drop);
  }
}